export { default } from "./VerticalCalloutCardLink";
